import { render, staticRenderFns } from "./ExchangeRecord.vue?vue&type=template&id=2bf28f64&scoped=true&"
import script from "./ExchangeRecord.vue?vue&type=script&lang=ts&"
export * from "./ExchangeRecord.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangeRecord.vue?vue&type=style&index=0&id=2bf28f64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf28f64",
  null
  
)

export default component.exports